module.exports = __webpack_public_path__ + "img/schoolsafetyappdownload.d7506cba.png";